import { useState, useEffect } from "react";
import { supabase } from "@/libs/supabase";
import type { Channel } from "@/types/channel/channel";

export const useChannel = (channelId?: string) => {
	const [channel, setChannel] = useState<Channel | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		if (!channelId) {
			setLoading(false);
			return;
		}

		const fetchChannel = async () => {
			try {
				const { data, error } = await supabase
					.from("channels")
					.select("*")
					.eq("id", channelId)
					.single();

				if (error) throw error;
				setChannel(data);
			} catch (e) {
				setError(
					e instanceof Error ? e : new Error("チャンネルの取得に失敗しました"),
				);
			} finally {
				setLoading(false);
			}
		};

		fetchChannel();

		// リアルタイム購読
		const subscription = supabase
			.channel(`channel:${channelId}`)
			.on(
				"postgres_changes",
				{
					event: "*",
					schema: "public",
					table: "channels",
					filter: `id=eq.${channelId}`,
				},
				(payload) => {
					fetchChannel();
				},
			)
			.subscribe();

		return () => {
			subscription.unsubscribe();
		};
	}, [channelId]);

	return { channel, loading, error };
};
